import { useCallback } from "react";
import TagManager from "react-gtm-module";

export function useBHCustomEventAnalyticsCall() {
  const analyticsCall = useCallback(
    (
      eventCategory: string,
      eventAction: string,
      eventLabel?: string,
      interaction?: boolean,
      pagination?: string,
      cdLanguage?: CD_LANGUAGE,
      isAutoPlay?: "yes" | "no",
      userKeywords?: string,
      clickReference?: string,
    ) => {
      TagManager.dataLayer({
        dataLayer: {
          event: "bhCustomEvent",
          eventCategory: eventCategory,
          eventAction: eventAction,
          ...(eventLabel && { eventLabel: eventLabel }),
          ...(interaction && { nonInteraction: interaction }),
          ...(pagination && { pagination: pagination }),
          ...(cdLanguage && { cd_language: cdLanguage }),
          ...(isAutoPlay && { audio_auto_played: isAutoPlay }),
          ...(userKeywords && { user_keyword: userKeywords }),
          ...(clickReference && { click_reference: clickReference }),
        },
      });
    },
    [],
  );

  return analyticsCall;
}

export enum CD_LANGUAGE {
  ENGLISH = "en",
  MALAY = "ms",
}
